const storage = {
    get: (key) => {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.warn(`[Storage] Failed to get ${key}:`, e.message);
            return null;
        }
    },
    set: (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.warn(`[Storage] Failed to set ${key}:`, e.message);
        }
    },
    remove: (key) => {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.warn(`[Storage] Failed to remove ${key}:`, e.message);
        }
    },
    clear: () => {
        try {
            localStorage.clear();
        } catch (e) {
            console.warn('[Storage] Failed to clear:', e.message);
        }
    }
};

export default storage;
